export async function getCapabilitiesResponse(url: string): Promise<any> {
    const response: Response = await fetch(url);
    return await response.text();
}